import moment from "moment";

export const initialTableUserReportOptions = {
    pageSize: 20,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 500,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

export const getTableUserReportColumns = [
    {
        title: "HN",
        field: "hnNumber",
        align: "center",
    },
    {
        title: "Name",
        field: "fullname",
        align: "center",
    },
    {
        title: "Age",
        field: "dob",
        align: "center",
        render: row => {
            const now = moment();
            const dob = moment(row?.dob);
            return now.diff(dob, "year");
        },
    },
    {
        title: "Phone",
        field: "phoneNumber",
        align: "center",
    },
    {
        title: "Application Date",
        field: "createdAt",
        align: "center",
        render: row => {
            return moment(row?.createdAt).format("DD/MM/YYYY HH:mm");
        },
    },
    {
        title: "Right",
        field: "patientPlan",
        align: "center",
    },
];

export const initialTableAppointReportOptions = {
    pageSize: 20,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 500,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

export const getTableAppointReportColumns = [
    {
        title: "HN",
        field: "UserMobile.hnNumber",
        align: "center",
    },
    {
        title: "Name",
        field: "UserMobile.fullname",
        align: "center",
    },
    {
        title: "Appointment Date",
        field: "appointDate",
        align: "center",
        render: row => moment(row?.appointDate).format("DD/MM/YYYY"),
    },
    {
        title: "Doctor",
        field: "doctor",
        align: "center",
        render: row => {
            return row.doctor || "-";
        },
    },
    {
        title: "Department",
        field: "clinic",
        align: "center",
        render: row => {
            return row.clinic || "-";
        },
    },
];
